export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-burst-new-21eae05e509a311224828f9b7091b91f.svg";